import { HasuraQueries } from "@/api/hasura/queries"
import { useQuery } from "@/api/utils/useQuery"
import { QueryResult } from "@/api/utils/types"
import { Configuration } from "@/constants/configuration"
import { DEFAULT_RENEWAL_WINDOW_PERIOD } from "@/constants/finance"

class ConfigurationServiceClass {
  getRenewalWindow(): QueryResult<number> {
    return useQuery({
      ...HasuraQueries.configuration.getConfigurationValue(
        Configuration.RENEWAL_WINDOW,
      ),
      placeholderData: DEFAULT_RENEWAL_WINDOW_PERIOD, // Default value for renewal period
      useRawResponse: true,
      parserFn: (data) => {
        if (!data?.configuration?.length) return DEFAULT_RENEWAL_WINDOW_PERIOD

        return parseInt(data.configuration[0].value)
      },
    })
  }

  getElectricityVatChangeFrom(): QueryResult<string | null> {
    return useQuery({
      ...HasuraQueries.configuration.getConfigurationValue(
        Configuration.ELECTRICITY_VAT_CHANGE_FROM,
      ),
      placeholderData: null,
      useRawResponse: true,
      parserFn: (data) => data?.configuration?.[0]?.value ?? null,
    })
  }

  getElectricityVatChangeNewRate(): QueryResult<number | null> {
    return useQuery({
      ...HasuraQueries.configuration.getConfigurationValue(
        Configuration.ELECTRICITY_VAT_CHANGE_NEW_RATE,
      ),
      placeholderData: null,
      useRawResponse: true,
      parserFn: (data) => {
        const value = data?.configuration?.[0]?.value
        if (value == null) return null
        const parsed = Number.parseFloat(value)
        // A malformed value must disable the change, not rebase prices to NaN.
        return Number.isFinite(parsed) ? parsed : null
      },
    })
  }
}

export const ConfigurationService = new ConfigurationServiceClass()
